export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function formatFCFA(n) {
  const v = Math.round(Number(n) || 0);
  return new Intl.NumberFormat("fr-FR").format(v) + " FCFA";
}

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
}

export function formatDateTime(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("fr-FR", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
}

export function fileUrl(path) {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  return `${BACKEND_URL}${path}`;
}

export function hasPromo(p) {
  const promo = Number(p?.promo_price) || 0;
  if (!(promo > 0 && promo < Number(p?.price || 0))) return false;
  if (p?.promo_end) {
    const raw = p.promo_end.length <= 10 ? p.promo_end + "T23:59:59" : p.promo_end;
    const end = new Date(raw);
    if (!isNaN(end.getTime()) && end.getTime() < Date.now()) return false;
  }
  return true;
}

export function effectivePrice(p) {
  return hasPromo(p) ? Number(p.promo_price) : Number(p?.price || 0);
}

export function discountPercent(p) {
  if (!hasPromo(p)) return 0;
  return Math.round(((Number(p.price) - Number(p.promo_price)) / Number(p.price)) * 100);
}

export function isLowStock(p) {
  const s = Number(p?.stock || 0);
  return s > 0 && s <= Number(p?.alert_threshold ?? 5);
}
